import { layerBelongsToView } from "./view-filter.helper"

/**
 * Construye la lista de capas que muestra el panel de Capas: filtra las capas del
 * viewer por la VISTA activa y mapea cada una con su nombre humano (nameByCode) y
 * su visibilidad real (del mapa layerVisibility; fallback a la pertenencia a la
 * vista en la primera apertura). Función PURA — la reactividad y el acceso al
 * viewer quedan en el componente.
 *
 * @param {Array<{name:string, displayName?:string, color?:*}>} layers - viewer.GetLayers(true)
 * @param {object} opts
 * @param {string} opts.displayView
 * @param {Object<string,boolean>} [opts.layerVisibility={}]
 * @param {Object<string,string>}  [opts.nameByCode={}]
 * @param {*} [opts.textLayers] - se pasa a layerBelongsToView
 * @returns {Array<{name, displayName, color, isVisible}>}
 */
export function buildFilterLayers(layers, { displayView, layerVisibility = {}, nameByCode = {}, textLayers } = {}) {
  return (layers || [])
    .filter(l => layerBelongsToView(l.name, displayView, textLayers))
    .map(l => ({
      name:        l.name,
      displayName: nameByCode[l.name] || l.displayName,
      color:       l.color,
      // Visibilidad real desde la fuente de verdad. Si aún no hay entrada
      // (primera apertura), cae a la pertenencia a la vista activa.
      isVisible:   layerVisibility[l.name] !== undefined
        ? layerVisibility[l.name]
        : layerBelongsToView(l.name, displayView, textLayers),
    }))
}
